import React, { useEffect, useState } from 'react';
import { getWithExpiry, setWithExpiry } from '../util/StorageWithExpiry';

const WARNING_KEY = 'hasSeenWarning';

const FirstVisitWarning: React.FC = () => {
  const [show, setShow] = useState(false);

  useEffect(() => {
    const seen = getWithExpiry<boolean>(WARNING_KEY);
    if (!seen) {
      setShow(true);
    }
  }, []);

  const handleClose = () => {
    setWithExpiry<boolean>(WARNING_KEY, true, 24 * 60 * 60 * 1000); // 24시간
    setShow(false);
  };

  if (!show) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
      <div className="bg-white rounded-lg shadow-lg w-full max-w-md mx-4">
        <div className="flex items-center px-6 py-4 border-b border-gray-200">
          <svg className="w-6 h-6 text-red-500 mr-2" fill="currentColor" viewBox="0 0 20 20">
            <path
              fillRule="evenodd"
              d="M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l6.516 11.591c.75 1.336-.213 2.99-1.743 2.99H3.484c-1.53 0-2.493-1.654-1.743-2.99L8.257 3.1zM11 13a1 1 0 10-2 0 1 1 0 002 0zm-1-2a1 1 0 01-1-1V8a1 1 0 112 0v2a1 1 0 01-1 1z"
              clipRule="evenodd"
            />
          </svg>
          <h3 className="text-lg font-semibold text-gray-800">주의사항</h3>
        </div>
        <div className="px-6 py-4 text-sm text-gray-700">
          이 서비스는 모든 데이터를 사용자의 PC에 저장합니다.
          <br />
          <strong className="text-red-600">공용 PC에서는 사용하지 마세요.</strong>
        </div>
        <div className="px-6 py-4 border-t border-gray-200 flex justify-end">
          <button
            onClick={handleClose}
            className="bg-indigo-600 hover:bg-indigo-700 text-white text-sm px-4 py-2 rounded-lg shadow"
          >
            확인
          </button>
        </div>
      </div>
    </div>
  );
};

export default FirstVisitWarning;
